<template>
  <div :class="spinnerClass" role="status" />
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    spinnerClass() {
      return `mr-spinner mr-spinner--${this.color}`;
    }
  }
};
</script>
<style scoped lang="scss">
.mr-spinner {
  width: 25px !important;
  height: 25px !important;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite spinner-border;
  animation: 0.75s linear infinite spinner-border;
  pointer-events: none;
  &--white {
    color: white;
  }
  &--black {
    color: black;
  }
}
</style>
